import { render, staticRenderFns } from "./r-smart-offer-bundle-treasure-type.vue?vue&type=template&id=78234138"
import script from "./r-smart-offer-bundle-treasure-type.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-treasure-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78234138')) {
      api.createRecord('78234138', component.options)
    } else {
      api.reload('78234138', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-treasure-type.vue?vue&type=template&id=78234138", function () {
      api.rerender('78234138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-treasure/r-smart-offer-bundle-treasure-type.vue"
export default component.exports